// /src/components/BackToAvatarFrameList.tsx
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@mui/material';

export const BackToAvatarFrameList: React.FC<{ mb?: number }> = ({
  mb = 1,
}) => {
  const history = useHistory();
  return (
    <Button
      onClick={() => history.push('/AvatarFrameGroupList')}
      size="small"
      sx={{
        px: 0,
        minWidth: 0,
        textTransform: 'none',
        color: 'text.secondary',
        mb,
        '&:hover': { background: 'transparent', color: 'text.primary' },
      }}
    >
      <span style={{ fontSize: 16, marginRight: 6 }}>←</span>
      アバターフレームグループ一覧へ
    </Button>
  );
};
